const browserMap = {
  ie: 'Internet Explorer',
  edge: 'Edge',
  chrome: 'Chrome',
  safari: 'Safari',
  firefox: 'Firefox'
};

// usage: {{'ie' | browser}}
export default function format(browser) {
  if (browser in browserMap) return browserMap[browser];
  return browser;
}
